export enum HotelBookingMethod {
  NotBooked = 0,
  AgentBookingPassive = 1,
  AgentBookingActive = 2,
  Manual = 3,
  FrontierOnline = 4
}
